import { get } from 'app/utils/axios/kheti'
import { FarmerProducts } from '../models/farmer'

const fetchFarmerProducts = async (farmerId: string, page?: number) => {
  try {
    let url = `/farmer-360/v1/farmer/${farmerId}/products`
    if (page) {
      url = url + `?page=${page}&limit=10`
    }
    return await get<FarmerProducts[]>(url)
  } catch (e) {
    return null
  }
}

export default fetchFarmerProducts
